<div class="app-header row  border-bottom">
    <div class="col-md-2 d-flex justify-content-start text-start align-self-stretch border-end">
            <a [routerLink]="homeRoute">
                <img class="firm-logo-image ps-3 py-1"
                     [src]="logoSrc"
                     [alt]="logoAlt"/>
            </a>
    </div>
    <div class="staff-details-container col-md-10 pe-4">
        <div id="current-user-container"
             class="current-user-container row">
            <div id="loggedInUserName" class="text-end col fs-5 fw-bold">
                <span *ngIf="isLoggedIn" id="loggedInName">
                    <span *ngIf="userProfile">
                        {{ userProfile.firstName || 'FirstNameMissing' }} {{ userProfile.lastName || 'LastNameMissing' }}
                    </span>
                </span>
            </div>
        </div>
        <div id="menu" class="text-end row">
            <ul class="nav small col d-flex flex-row-reverse">
                <li class="nav-item">
                    <button *ngIf="isLoggedIn" id="app-logout" type="button" class="btn btn-link nav-link" (click)="endSession()">Logout
                    </button>
                    <button *ngIf="!isLoggedIn" id="app-login" type="button" class="btn btn-link nav-link" (click)="startSession()">Login
                    </button>
                </li>
            </ul>
        </div>
    </div>
</div>
